<template>
	<div class="channelShopCell">
		<div v-if="row.cate_name" class="fz-12 yx-color-text-regular">
			{{ row.cate_name }}
		</div>
		<div class="flex flex-align-center">
			<img class="shop_img" :src="row.product_pic" alt="" />
			<div class="box ml-10 PingFang yx-color-text-primary fz-13">
				<div class="flex">
					<a v-if="column.isKs" :href="row.product_detail_url" target="_blank" class="title yx-color-text-regular ellipsis hover pointer">{{
						row.product_name
					}}</a>
					<p v-else :style="{ 'max-width': column.maxWidth ? column.maxWidth : '300px' }" class="title ellipsis">{{ row.product_name }}</p>
					<el-tooltip class="item" effect="dark" placement="top">
						<div slot="content" class="content">
							<span>商品ID</span><span class="ml-10">{{ row.third_product_id }}</span>
							<img src="@/assets/public/copy-icon.png" alt="" @click="copy(row.third_product_id)" />
						</div>
						<span class="ID-sign yx-color-primary nowrap">ID</span>
					</el-tooltip>
				</div>
				<div class="flex flex-align-center">
					<span>售价：</span><span>¥{{ row.price }}</span> <span class="ml-10">库存：</span><span>{{ row.product_stock }}</span>
					<span class="ml-10" v-if="column.key === 'myActivities'">销量：</span><span>{{ row.sales }}</span>
					<p class="ml-10 ellipsis category" v-if="column.key === 'colonelActivitySquare'">类目：{{ row.cate_name }}</p>
				</div>
				<div class="flex flex-align-center" v-if="column.key === 'colonelActivitySquare'">
					<!-- 没有同步的 展示获取中， 需要改变颜色样式 -->
					<span>店铺：</span><span :class="{ 'color-gy-7': row.product_sync_status === false }">{{ row.shop_name }}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from './mixin';
export default {
	data() {
		return {};
	},
	mixins: [mixin],
	methods: {
		copy(value) {
			var inputTest = document.createElement('textarea');
			inputTest.value = value;
			document.body.appendChild(inputTest);
			inputTest.select();
			document.execCommand('Copy');
			inputTest.className = 'oInput';
			inputTest.style.display = 'none';
			this.$message.success('复制成功');
			document.body.removeChild(inputTest);
		},
	},
};
</script>
<style lang="less" scoped>
.title {
	max-width: 300px;
}
.ellipsis {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.category {
	width: 150px;
}
.shop_img {
	width: 40px;
	height: 40px;
	border-radius: 5px;
}
.ID-sign {
	padding: 0px 4px;
	border-radius: 2px;
	margin-left: 3px;
	background-color: @color-parachrome;
	cursor: default;
}
.content {
	display: flex;
	align-items: center;
	img {
		margin-left: 8px;
		width: 16px;
		height: 16px;
		cursor: pointer;
	}
}
</style>